var _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMissing(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.561 20.561",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "missing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20.561v20.561H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#missing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.01 17.345l-7.065-7.065 7.065-7.065A1.884 1.884 0 0017.346.551l-7.065 7.065L3.216.551A1.884 1.884 0 00.552 3.215l7.065 7.065-7.065 7.065a1.884 1.884 0 102.664 2.664l7.065-7.065 7.065 7.065a1.884 1.884 0 102.664-2.664",
    fill: "#fb4856"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissing);
export default ForwardRef;